import { Component, OnInit } from '@angular/core';
import { SaveService } from '../services/save.service';

@Component({
  selector: 'app-how-works',
  templateUrl: './how-works.component.html',
  styleUrls: ['./how-works.component.css']
})
export class HowWorksComponent implements OnInit {

  brandName;
  
  constructor(private saveService: SaveService) { }

  ngOnInit() {
    this.brandName = this.saveService.getBrandName();  
    $('.navbar ul').css({'padding-top':'0px'});
    $('.logo').css({'padding-bottom': '15px'});
  }

}
